import { StorePermissions, curriedGetStoreStatus } from './types';

import { initialStoreState } from '.';

/**
 * Creates a function to get a store's status for store selection 1.0
 *
 * @param {ServiceMode} selectedServiceMode the default service mode to check against
 * @param {ServiceMode} serviceMode service mode to check
 * @param {ServiceModeStatus} serviceModeStatuses the service mode status of the store
 */
export const curriedGetStoreStatusV1: curriedGetStoreStatus = ({
  store,
  serviceModeStatuses,
  selectedServiceMode
}) => (serviceMode = selectedServiceMode) => {
  if (store === initialStoreState || !serviceMode) {
    return StorePermissions.NO_STORE_SELECTED;
  }

  const serviceModeStatus = serviceModeStatuses[serviceMode];

  return serviceModeStatus.available && !serviceModeStatus.disabled
    ? StorePermissions.OPEN_AND_AVAILABLE
    : StorePermissions.CLOSED;
};

/**
 * Creates a function to get a store's status for store selection 2.0
 *
 * @param {ServiceMode} selectedServiceMode the default service mode to check against
 * @param {ServiceMode} serviceMode service mode to check
 * @param {ServiceModeStatus} serviceModeStatuses the service mode status of the store
 */
export const curriedGetStoreStatusV2: curriedGetStoreStatus = ({
  store,
  serviceModeStatuses,
  selectedServiceMode
}) => (serviceMode = selectedServiceMode) => {
  if (!store || !serviceMode) {
    return StorePermissions.NO_STORE_SELECTED;
  }

  const serviceModeStatus = serviceModeStatuses[serviceMode];

  if (serviceModeStatus.open && !serviceModeStatus.disabled) {
    return serviceModeStatus.available
      ? StorePermissions.OPEN_AND_AVAILABLE
      : StorePermissions.OPEN_AND_UNAVAILABLE;
  }

  return StorePermissions.CLOSED;
};
